<mat-toolbar>
  <mat-toolbar-row class="justify-content-between">
    <button mat-icon-button (click)="drawer.toggle()">
      <mat-icon >menu</mat-icon>
    </button>
    <div class="row mr-2 ml-auto">
      <ul class="row m-0 align-items-center">
        <li>
          <button
            mat-button
            [matMenuTriggerFor]="menu"
            class="user mt-2 d-flex align-items-center">
            <img src="./assets/userImg.png" alt="" class="user-image mr-1 p-2" />
            Admin
            <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="logout()">
              <mat-icon>exit_to_app</mat-icon>
              Logout
            </button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </mat-toolbar-row>
</mat-toolbar>


<mat-sidenav-container class="example-container">
  <mat-sidenav #drawer mode="side" opened role="navigation">
    <mat-nav-list>
      <div class="logo py-4">
        <img src="./assets/Logo.png" alt="Company Logo" />
      </div>
      <mat-divider></mat-divider><br>
    
      <a mat-list-item routerLinkActive="list-item-active" (click)="gotoPage()">
        <mat-icon>home</mat-icon> Home
      </a>
      <a mat-list-item routerLinkActive="list-item-active" routerLink="/user">
        <mat-icon>dashboard</mat-icon> User Management
      </a>
      <a mat-list-item routerLinkActive="list-item-active" routerLink="/document">
        <mat-icon>dashboard</mat-icon> Document Verification
      </a>
      <a mat-list-item routerLinkActive="list-item-active" routerLink="/MarketPlace">
        <mat-icon>dashboard</mat-icon> Market Rate Updates
      </a>
      <a mat-list-item routerLinkActive="list-item-active" routerLink="/Govt-schemes">
        <mat-icon>dashboard</mat-icon> Govt - Schemes
      </a>
    
      <a mat-list-item> <mat-icon>edit</mat-icon>BuyAndSellAnalytics</a>
      <a mat-list-item> <mat-icon>edit</mat-icon>Daily Updates</a>
      <a mat-list-item> <mat-icon>edit</mat-icon>Tickets</a>
      <a mat-list-item> <mat-icon>edit</mat-icon>Notification </a>
       </mat-nav-list>
      </mat-sidenav>
     <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>